// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Design System - Dark Theme
 * Foundation for the entire application — dark indigo
 */

:root {
  /* ═══════════════════════════════════════════════════════════ */
  /* TYPOGRAPHY */
  /* ═══════════════════════════════════════════════════════════ */
  --font-primary: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  --font-mono: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;

  --text-xs: 12px;
  --text-sm: 13px;
  --text-base: 14px;
  --text-lg: 16px;
  --text-xl: 18px;
  --text-2xl: 22px;
  --text-3xl: 28px;

  /* Line heights */
  --line-tight: 1.25;
  --line-normal: 1.5;
  --line-relaxed: 1.75;

  /* Font weights */
  --fw-regular: 400;
  --fw-medium: 500;
  --fw-semibold: 600;
  --fw-bold: 700;

  /* ═══════════════════════════════════════════════════════════ */
  /* COLORS - DARK THEME (replaces light slate scale)          */
  /* ═══════════════════════════════════════════════════════════ */
  /* Backgrounds / surfaces */
  --slate-50:  #07090f;    /* page background */
  --slate-100: #0d0f1a;    /* card / surface */
  --slate-200: rgba(255,255,255,.07);   /* borders */
  --slate-300: rgba(255,255,255,.14);   /* border hover */
  --slate-400: rgba(255,255,255,.35);   /* muted text */
  --slate-500: rgba(255,255,255,.45);   /* placeholder */
  --slate-600: rgba(255,255,255,.55);   /* secondary text */
  --slate-700: rgba(255,255,255,.70);   /* body text */
  --slate-900: #e2e8f0;                 /* primary text (light on dark) */

  /* ═══════════════════════════════════════════════════════════ */
  /* COLORS - ACCENT (Indigo)                                  */
  /* ═══════════════════════════════════════════════════════════ */
  --blue-50:  rgba(99,102,241,.15);   /* active link bg */
  --blue-500: #6366f1;
  --blue-600: #6366f1;
  --blue-700: #818cf8;

  /* Shorthand accent aliases */
  --accent:      #6366f1;
  --accent-l:    #818cf8;
  --accent-2:    #7c3aed;    /* secondary gradient shade */
  --accent-dark: #4f46e5;    /* darker for hover states  */
  --accent-rgb:  99,102,241; /* channels for rgba(var(--accent-rgb),opacity) */
  --accent-g:    rgba(99,102,241,.25);

  /* Surface helpers — used by inline styles and components */
  --bg-card:    #0d0f1a;
  --bg-surface: #0d0f1a;
  --bg-toolbar: rgba(255,255,255,.025);
  --bg-input:   rgba(255,255,255,.05);
  --border:     rgba(255,255,255,.07);
  --text-primary:   #e2e8f0;
  --text-secondary: rgba(255,255,255,.55);
  --text-muted:     rgba(255,255,255,.35);

  /* ═══════════════════════════════════════════════════════════ */
  /* COLORS - FUNCTIONAL */
  /* ═══════════════════════════════════════════════════════════ */
  --green-50:  rgba(16,185,129,.15);
  --green-600: #10b981;
  --amber-50:  rgba(245,158,11,.15);
  --amber-600: #f59e0b;
  --red-50:    rgba(239,68,68,.15);
  --red-600:   #ef4444;

  /* ═══════════════════════════════════════════════════════════ */
  /* COLORS - CANVAS / TOPOLOGY / PORT STATUS                  */
  /* ═══════════════════════════════════════════════════════════ */
  /* Port status dots */
  --port-complete-dot:  #0d9488;
  --port-wall-dot:      #8b5cf6;
  --port-switch-dot:    #3b82f6;
  --port-free-dot:      #10b981;
  --port-connected-dot: #86efac;
  --port-uplink-dot:    #fcd34d;

  /* Port status backgrounds */
  --port-complete-bg:  rgba(13,148,136,.15);
  --port-wall-bg:      rgba(139,92,246,.15);
  --port-switch-bg:    rgba(59,130,246,.12);
  --port-free-bg:      rgba(16,185,129,.1);
  --port-selected-bg:  rgba(249,115,22,.18);
  --port-selected-bd:  #f97316;

  /* RSTP role colours */
  --rstp-root:        #2563eb;
  --rstp-designated:  #3b82f6;
  --rstp-alternate:   #f59e0b;
  --rstp-backup:      #b45309;
  --rstp-disabled:    #9ca3af;

  /* Service status colours */
  --status-running:     #22c55e;
  --status-stopped:     #ef4444;
  --status-maintenance: #eab308;
  --status-degraded:    #f97316;
  --status-unknown:     #94a3b8;

  /* Criticality ring */
  --crit-critical: #ef4444;
  --crit-high:     #f97316;
  --crit-medium:   #eab308;
  --crit-low:      #3b82f6;

  /* Canvas node colours */
  --node-self-bg:     #1e40af;
  --node-self-stroke: #1e3a8a;
  --node-self-text:   #e0f2fe;
  --node-self-sub:    #93c5fd;
  --node-edge-label-bg: #fff;
  --node-selected-bg:   rgba(99,102,241,.15);
  --node-selected-bd:   var(--accent);
  --node-link-text:     var(--text-muted);

  /* Uplink cloud stub */
  --uplink-bg:     rgba(99,102,241,.08);
  --uplink-stroke: var(--accent-l);
  --uplink-text:   var(--accent);
  --uplink-sub:    var(--text-muted);

  /* Edge highlight in dependency map */
  --edge-highlight: var(--accent);
  --edge-normal:    var(--text-muted);

  /* Connection banner / success */
  --conn-banner-bg:     var(--green-50);
  --conn-banner-bd:     #86efac;
  --conn-arrow:         #16a34a;
  --conn-cable-text:    var(--text-secondary);

  /* Disconnect / error */
  --error-bg:     var(--red-50);
  --error-bd:     #fca5a5;
  --error-text:   var(--red-600);

  /* Warn / daisy-chain orange */
  --warn-bg:   rgba(249,115,22,.08);
  --warn-bd:   #fb923c;
  --warn-text: #fb923c;

  /* Wall outlet purple accents */
  --wall-accent:      #a78bfa;
  --wall-banner-bg:   rgba(139,92,246,.08);
  --wall-banner-bd:   #c4b5fd;

  /* Modal overlay */
  --modal-overlay: rgba(0,0,0,.45);

  /* Tab bar active */
  --tab-active-bd:   var(--accent);
  --tab-active-text: var(--accent-l);
  --tab-inactive-text: var(--text-muted);

  /* Button primary */
  --btn-primary:       var(--accent);
  --btn-primary-hover: var(--accent-dark);
  --btn-danger:        #dc2626;
  --btn-danger-hover:  #b91c1c;

  /* ── Port card colours (SwitchPortsTab) ── */
  --spt-outlet-bg:     #ede9fe;
  --spt-outlet-fg:     #5b21b6;
  --spt-outlet-bd:     #8b5cf6;
  --spt-connected-bg:  #86efac;
  --spt-connected-fg:  #14532d;
  --spt-uplink-bg:     #fcd34d;
  --spt-uplink-fg:     #78350f;
  --spt-free-fg:       #475569;
  --spt-inactive-bg:   #94a3b8;
  --spt-inactive-fg:   #64748b;
  --spt-mirror-bg:     linear-gradient(135deg, #a78bfa, #7c3aed);
  --spt-mirror-bd:     #6d28d9;
  --spt-empty-bg1:     #f1f5f9;
  --spt-empty-bg2:     #e2e8f0;
  --spt-empty-fg:      #94a3b8;
  --spt-empty-bd:      #cbd5e1;

  /* Connector badge colours */
  --port-conn-default-bg:  #e5e7eb;
  --port-conn-default-fg:  #374151;
  --port-conn-fiber-bg:    #fef3c7;
  --port-conn-fiber-fg:    #92400e;
  --port-conn-sfp-bg:      #dbeafe;
  --port-conn-sfp-fg:      #1e40af;

  /* Port state colours (PortMapModal) */
  --port-patched:       #86efac;
  --port-pending:       #fcd34d;
  --port-free:          #e2e8f0;
  --port-inactive:      #94a3b8;
  --port-inactive-text: #64748b;
  --port-patched-text:  #14532d;
  --port-pending-text:  #78350f;
  --port-free-text:     #475569;

  /* RSTP role badges */
  --rstp-root-bg:        #dcfce7;
  --rstp-root-fg:        #15803d;
  --rstp-designated-bg:  #dbeafe;
  --rstp-designated-fg:  #1d4ed8;
  --rstp-alternate-bg:   #fef3c7;
  --rstp-alternate-fg:   #b45309;
  --rstp-backup-bg:      #fef9c3;
  --rstp-backup-fg:      #92400e;
  --rstp-disabled-bg:    #f3f4f6;
  --rstp-disabled-fg:    #6b7280;

  /* Editor / form colours */
  --editor-bg:     var(--bg-card);
  --editor-header-text: var(--text-primary);
  --editor-label:  var(--text-muted);
  --badge-on-bg:   #dcfce7;
  --badge-on-fg:   #166534;
  --badge-off-bg:  var(--bg-toolbar);
  --badge-off-fg:  var(--text-secondary);

  /* ═══════════════════════════════════════════════════════════ */
  /* SHADOWS */
  /* ═══════════════════════════════════════════════════════════ */
  --shadow-sm: 0 1px 3px rgba(0,0,0,.4);
  --shadow-md: 0 4px 12px rgba(0,0,0,.5);
  --shadow-lg: 0 12px 32px rgba(0,0,0,.6);

  /* ═══════════════════════════════════════════════════════════ */
  /* SPACING */
  /* ═══════════════════════════════════════════════════════════ */
  --spacing-xs: 4px;
  --spacing-sm: 8px;
  --spacing-md: 12px;
  --spacing-lg: 16px;
  --spacing-xl: 24px;
  --spacing-2xl: 32px;

  /* ═══════════════════════════════════════════════════════════ */
  /* BORDER RADIUS */
  /* ═══════════════════════════════════════════════════════════ */
  --radius-xs: 2px;
  --radius-sm: 4px;
  --radius-md: 6px;
  --radius-lg: 8px;
  --radius-xl: 12px;
  --radius-full: 9999px;

  /* ═══════════════════════════════════════════════════════════ */
  /* TRANSITIONS */
  /* ═══════════════════════════════════════════════════════════ */
  --transition-fast: 0.15s ease;
  --transition-normal: 0.3s ease;
}

/* ═══════════════════════════════════════════════════════════ */
/* PALETTE OVERRIDES — each block only redefines what changes */
/* ═══════════════════════════════════════════════════════════ */

/* ── Midnight (Blue) ───────────────────────────────────────── */
[data-theme="midnight"] {
  --slate-50:    #010a1e;
  --slate-100:   #071525;
  --bg-card:     #071525;
  --bg-surface:  #071525;
  --accent:      #3b82f6;
  --accent-l:    #60a5fa;
  --accent-2:    #2563eb;
  --accent-dark: #1d4ed8;
  --accent-rgb:  59,130,246;
  --accent-g:    rgba(59,130,246,.25);
  --blue-50:     rgba(59,130,246,.15);
  --blue-500:    #3b82f6;
  --blue-600:    #3b82f6;
  --blue-700:    #60a5fa;
  --bs-body-bg:  #010a1e;
  --bs-card-bg:  #071525;
}

/* ── Ocean (Cyan) ─────────────────────────────────────────── */
[data-theme="ocean"] {
  --slate-50:    #031318;
  --slate-100:   #071c22;
  --bg-card:     #071c22;
  --bg-surface:  #071c22;
  --accent:      #06b6d4;
  --accent-l:    #22d3ee;
  --accent-2:    #0891b2;
  --accent-dark: #0e7490;
  --accent-rgb:  6,182,212;
  --accent-g:    rgba(6,182,212,.25);
  --blue-50:     rgba(6,182,212,.15);
  --blue-500:    #06b6d4;
  --blue-600:    #06b6d4;
  --blue-700:    #22d3ee;
  --bs-body-bg:  #031318;
  --bs-card-bg:  #071c22;
}

/* ── Aurora (Emerald) ─────────────────────────────────────── */
[data-theme="aurora"] {
  --slate-50:    #031208;
  --slate-100:   #071a0e;
  --bg-card:     #071a0e;
  --bg-surface:  #071a0e;
  --accent:      #10b981;
  --accent-l:    #34d399;
  --accent-2:    #059669;
  --accent-dark: #047857;
  --accent-rgb:  16,185,129;
  --accent-g:    rgba(16,185,129,.25);
  --blue-50:     rgba(16,185,129,.15);
  --blue-500:    #10b981;
  --blue-600:    #10b981;
  --blue-700:    #34d399;
  --bs-body-bg:  #031208;
  --bs-card-bg:  #071a0e;
}

/* ── Dusk (Rose) ──────────────────────────────────────────── */
[data-theme="dusk"] {
  --slate-50:    #130810;
  --slate-100:   #1c0e17;
  --bg-card:     #1c0e17;
  --bg-surface:  #1c0e17;
  --accent:      #ec4899;
  --accent-l:    #f472b6;
  --accent-2:    #db2777;
  --accent-dark: #be185d;
  --accent-rgb:  236,72,153;
  --accent-g:    rgba(236,72,153,.25);
  --blue-50:     rgba(236,72,153,.15);
  --blue-500:    #ec4899;
  --blue-600:    #ec4899;
  --blue-700:    #f472b6;
  --bs-body-bg:  #130810;
  --bs-card-bg:  #1c0e17;
}

/* ── Sunset (Amber) ───────────────────────────────────────── */
[data-theme="sunset"] {
  --slate-50:    #130a03;
  --slate-100:   #1a1006;
  --bg-card:     #1a1006;
  --bg-surface:  #1a1006;
  --accent:      #f59e0b;
  --accent-l:    #fbbf24;
  --accent-2:    #d97706;
  --accent-dark: #b45309;
  --accent-rgb:  245,158,11;
  --accent-g:    rgba(245,158,11,.25);
  --blue-50:     rgba(245,158,11,.15);
  --blue-500:    #f59e0b;
  --blue-600:    #f59e0b;
  --blue-700:    #fbbf24;
  --bs-body-bg:  #130a03;
  --bs-card-bg:  #1a1006;
}

/* ── Light ────────────────────────────────────────────────── */
[data-theme="light"] {
  --slate-50:    #f1f5f9;
  --slate-100:   #ffffff;
  --slate-200:   rgba(0,0,0,.08);
  --slate-300:   rgba(0,0,0,.15);
  --slate-400:   rgba(0,0,0,.35);
  --slate-500:   rgba(0,0,0,.45);
  --slate-600:   rgba(0,0,0,.55);
  --slate-700:   rgba(0,0,0,.70);
  --slate-900:   #0f172a;
  --bg-card:     #ffffff;
  --bg-surface:  #ffffff;
  --bg-toolbar:  rgba(0,0,0,.025);
  --bg-input:    rgba(0,0,0,.04);
  --border:      rgba(0,0,0,.08);
  --text-primary:   #0f172a;
  --text-secondary: rgba(0,0,0,.55);
  --text-muted:     rgba(0,0,0,.35);
  --accent:      #6366f1;
  --accent-l:    #4f46e5;
  --accent-2:    #7c3aed;
  --accent-dark: #4338ca;
  --accent-rgb:  99,102,241;
  --accent-g:    rgba(99,102,241,.18);
  --blue-50:     rgba(99,102,241,.12);
  --blue-500:    #6366f1;
  --blue-600:    #6366f1;
  --blue-700:    #4f46e5;
  --bs-body-bg:    #f1f5f9;
  --bs-body-color: #0f172a;
  --bs-card-bg:    #ffffff;
  --bs-border-color: rgba(0,0,0,.1);
  /* Canvas overrides for light */
  --node-self-bg:     #1e40af;
  --node-self-stroke: #1e3a8a;
  --node-self-text:   #e0f2fe;
  --node-self-sub:    #93c5fd;
  --node-edge-label-bg: #fff;
  --node-selected-bg: #eff6ff;
  --uplink-bg:     #f0f9ff;
  --uplink-stroke: #bae6fd;
  --uplink-text:   #0369a1;
  --uplink-sub:    #64748b;
  --conn-banner-bg: #f0fdf4;
  --conn-arrow:     #16a34a;
  --error-bg:       #fee2e2;
  --error-bd:       #fca5a5;
  --warn-bg:        #fff7ed;
  --warn-bd:        #fed7aa;
  --warn-text:      #9a3412;
  --wall-banner-bg: #faf5ff;
  --wall-banner-bd: #c4b5fd;
  --modal-overlay:  rgba(15,23,42,.55);
  --editor-bg:      #ffffff;
  --spt-empty-bg1:  #f1f5f9;
  --spt-empty-bg2:  #e2e8f0;
}

/* ── Light Sky (Blue) ─────────────────────────────────────── */
[data-theme="light-sky"] {
  --slate-50:    #f0f5ff;
  --slate-100:   #ffffff;
  --slate-200:   rgba(0,0,0,.08);
  --slate-300:   rgba(0,0,0,.15);
  --slate-400:   rgba(0,0,0,.35);
  --slate-500:   rgba(0,0,0,.45);
  --slate-600:   rgba(0,0,0,.55);
  --slate-700:   rgba(0,0,0,.70);
  --slate-900:   #0c1e3a;
  --bg-card:     #ffffff;
  --bg-surface:  #ffffff;
  --bg-toolbar:  rgba(0,0,0,.025);
  --bg-input:    rgba(0,0,0,.04);
  --border:      rgba(0,0,0,.08);
  --text-primary:   #0c1e3a;
  --text-secondary: rgba(0,0,0,.55);
  --text-muted:     rgba(0,0,0,.35);
  --accent:      #0284c7;
  --accent-l:    #0369a1;
  --accent-2:    #0ea5e9;
  --accent-dark: #075985;
  --accent-rgb:  2,132,199;
  --accent-g:    rgba(2,132,199,.18);
  --blue-50:     rgba(2,132,199,.12);
  --blue-500:    #0284c7;
  --blue-600:    #0284c7;
  --blue-700:    #0369a1;
  --shadow-sm:   0 1px 3px rgba(0,0,0,.08);
  --shadow-md:   0 4px 12px rgba(0,0,0,.1);
  --shadow-lg:   0 12px 32px rgba(0,0,0,.12);
  --bs-body-bg:    #f0f5ff;
  --bs-body-color: #0c1e3a;
  --bs-card-bg:    #ffffff;
  --bs-border-color: rgba(0,0,0,.1);
}

/* ── Light Teal ───────────────────────────────────────────── */
[data-theme="light-teal"] {
  --slate-50:    #f0fdfa;
  --slate-100:   #ffffff;
  --slate-200:   rgba(0,0,0,.08);
  --slate-300:   rgba(0,0,0,.15);
  --slate-400:   rgba(0,0,0,.35);
  --slate-500:   rgba(0,0,0,.45);
  --slate-600:   rgba(0,0,0,.55);
  --slate-700:   rgba(0,0,0,.70);
  --slate-900:   #0f2b2b;
  --bg-card:     #ffffff;
  --bg-surface:  #ffffff;
  --bg-toolbar:  rgba(0,0,0,.025);
  --bg-input:    rgba(0,0,0,.04);
  --border:      rgba(0,0,0,.08);
  --text-primary:   #0f2b2b;
  --text-secondary: rgba(0,0,0,.55);
  --text-muted:     rgba(0,0,0,.35);
  --accent:      #0d9488;
  --accent-l:    #0f766e;
  --accent-2:    #14b8a6;
  --accent-dark: #115e59;
  --accent-rgb:  13,148,136;
  --accent-g:    rgba(13,148,136,.18);
  --blue-50:     rgba(13,148,136,.12);
  --blue-500:    #0d9488;
  --blue-600:    #0d9488;
  --blue-700:    #0f766e;
  --shadow-sm:   0 1px 3px rgba(0,0,0,.08);
  --shadow-md:   0 4px 12px rgba(0,0,0,.1);
  --shadow-lg:   0 12px 32px rgba(0,0,0,.12);
  --bs-body-bg:    #f0fdfa;
  --bs-body-color: #0f2b2b;
  --bs-card-bg:    #ffffff;
  --bs-border-color: rgba(0,0,0,.1);
}

/* ── Light Rose ───────────────────────────────────────────── */
[data-theme="light-rose"] {
  --slate-50:    #fff1f2;
  --slate-100:   #ffffff;
  --slate-200:   rgba(0,0,0,.08);
  --slate-300:   rgba(0,0,0,.15);
  --slate-400:   rgba(0,0,0,.35);
  --slate-500:   rgba(0,0,0,.45);
  --slate-600:   rgba(0,0,0,.55);
  --slate-700:   rgba(0,0,0,.70);
  --slate-900:   #2a0f1e;
  --bg-card:     #ffffff;
  --bg-surface:  #ffffff;
  --bg-toolbar:  rgba(0,0,0,.025);
  --bg-input:    rgba(0,0,0,.04);
  --border:      rgba(0,0,0,.08);
  --text-primary:   #2a0f1e;
  --text-secondary: rgba(0,0,0,.55);
  --text-muted:     rgba(0,0,0,.35);
  --accent:      #e11d48;
  --accent-l:    #be123c;
  --accent-2:    #f43f5e;
  --accent-dark: #9f1239;
  --accent-rgb:  225,29,72;
  --accent-g:    rgba(225,29,72,.18);
  --blue-50:     rgba(225,29,72,.12);
  --blue-500:    #e11d48;
  --blue-600:    #e11d48;
  --blue-700:    #be123c;
  --shadow-sm:   0 1px 3px rgba(0,0,0,.08);
  --shadow-md:   0 4px 12px rgba(0,0,0,.1);
  --shadow-lg:   0 12px 32px rgba(0,0,0,.12);
  --bs-body-bg:    #fff1f2;
  --bs-body-color: #2a0f1e;
  --bs-card-bg:    #ffffff;
  --bs-border-color: rgba(0,0,0,.1);
}

/* ── Light Amber ──────────────────────────────────────────── */
[data-theme="light-amber"] {
  --slate-50:    #fffbeb;
  --slate-100:   #ffffff;
  --slate-200:   rgba(0,0,0,.08);
  --slate-300:   rgba(0,0,0,.15);
  --slate-400:   rgba(0,0,0,.35);
  --slate-500:   rgba(0,0,0,.45);
  --slate-600:   rgba(0,0,0,.55);
  --slate-700:   rgba(0,0,0,.70);
  --slate-900:   #2a1f0a;
  --bg-card:     #ffffff;
  --bg-surface:  #ffffff;
  --bg-toolbar:  rgba(0,0,0,.025);
  --bg-input:    rgba(0,0,0,.04);
  --border:      rgba(0,0,0,.08);
  --text-primary:   #2a1f0a;
  --text-secondary: rgba(0,0,0,.55);
  --text-muted:     rgba(0,0,0,.35);
  --accent:      #d97706;
  --accent-l:    #b45309;
  --accent-2:    #f59e0b;
  --accent-dark: #92400e;
  --accent-rgb:  217,119,6;
  --accent-g:    rgba(217,119,6,.18);
  --blue-50:     rgba(217,119,6,.12);
  --blue-500:    #d97706;
  --blue-600:    #d97706;
  --blue-700:    #b45309;
  --shadow-sm:   0 1px 3px rgba(0,0,0,.08);
  --shadow-md:   0 4px 12px rgba(0,0,0,.1);
  --shadow-lg:   0 12px 32px rgba(0,0,0,.12);
  --bs-body-bg:    #fffbeb;
  --bs-body-color: #2a1f0a;
  --bs-card-bg:    #ffffff;
  --bs-border-color: rgba(0,0,0,.1);
}

/* ── Light Emerald ────────────────────────────────────────── */
[data-theme="light-emerald"] {
  --slate-50:    #ecfdf5;
  --slate-100:   #ffffff;
  --slate-200:   rgba(0,0,0,.08);
  --slate-300:   rgba(0,0,0,.15);
  --slate-400:   rgba(0,0,0,.35);
  --slate-500:   rgba(0,0,0,.45);
  --slate-600:   rgba(0,0,0,.55);
  --slate-700:   rgba(0,0,0,.70);
  --slate-900:   #0a2a1b;
  --bg-card:     #ffffff;
  --bg-surface:  #ffffff;
  --bg-toolbar:  rgba(0,0,0,.025);
  --bg-input:    rgba(0,0,0,.04);
  --border:      rgba(0,0,0,.08);
  --text-primary:   #0a2a1b;
  --text-secondary: rgba(0,0,0,.55);
  --text-muted:     rgba(0,0,0,.35);
  --accent:      #059669;
  --accent-l:    #047857;
  --accent-2:    #10b981;
  --accent-dark: #065f46;
  --accent-rgb:  5,150,105;
  --accent-g:    rgba(5,150,105,.18);
  --blue-50:     rgba(5,150,105,.12);
  --blue-500:    #059669;
  --blue-600:    #059669;
  --blue-700:    #047857;
  --shadow-sm:   0 1px 3px rgba(0,0,0,.08);
  --shadow-md:   0 4px 12px rgba(0,0,0,.1);
  --shadow-lg:   0 12px 32px rgba(0,0,0,.12);
  --bs-body-bg:    #ecfdf5;
  --bs-body-color: #0a2a1b;
  --bs-card-bg:    #ffffff;
  --bs-border-color: rgba(0,0,0,.1);
}

/* ═══════════════════════════════════════════════════════════ */
/* GLOBAL STYLES */
/* ═══════════════════════════════════════════════════════════ */

* {
  box-sizing: border-box;
}

html {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

body {
  font-family: var(--font-primary);
  font-size: var(--text-base);
  line-height: var(--line-normal);
  color: var(--slate-900);
  background-color: var(--slate-50);
  margin: 0;
  padding: 0;
}

/* ── Grid overlay ────────────────────────────────────────────
 * Retirado: la rejilla que se veía en todas las pantallas vive ahora en
 * \`styles/background.css\` como opción (\`data-bg="mesh"\`) y por defecto se
 * sustituye por un campo de degradados difuminados. */

/* ═══════════════════════════════════════════════════════════ */
/* HEADINGS */
/* ═══════════════════════════════════════════════════════════ */

h1, h2, h3, h4, h5, h6 {
  margin: 0;
  font-weight: var(--fw-bold);
  line-height: var(--line-tight);
  color: var(--slate-900);  /* now light (#e2e8f0) on dark bg */
}

/* ═══════════════════════════════════════════════════════════ */
/* TEXT UTILITIES */
/* ═══════════════════════════════════════════════════════════ */

.text-primary   { color: var(--slate-900); }
.text-secondary { color: var(--slate-600); }
.text-muted     { color: var(--slate-400); }
.text-success   { color: var(--green-600); }
.text-warning   { color: var(--amber-600); }
.text-error     { color: var(--red-600); }
.text-link      { color: var(--accent-l); }

.text-xs { font-size: var(--text-xs); }
.text-sm { font-size: var(--text-sm); }
.text-base { font-size: var(--text-base); }
.text-lg { font-size: var(--text-lg); }

.font-regular { font-weight: var(--fw-regular); }
.font-medium { font-weight: var(--fw-medium); }
.font-semibold { font-weight: var(--fw-semibold); }
.font-bold { font-weight: var(--fw-bold); }

/* ═══════════════════════════════════════════════════════════ */
/* SCROLLBAR STYLING */
/* ═══════════════════════════════════════════════════════════ */

::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: transparent;
}

::-webkit-scrollbar-thumb {
  background: var(--slate-300);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: var(--slate-400);
}
`, "",{"version":3,"sources":["webpack://./src/styles/design-system.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAIF;EACE,gEAAgE;EAChE,eAAe;EACf,gEAAgE;EAChE,kFAAkF;EAClF,wDAAwD;;EAExD,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gBAAgB;;EAEhB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;;EAEpB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;;EAEd,gEAAgE;EAChE,8DAA8D;EAC9D,gEAAgE;EAChE,2BAA2B;EAC3B,oBAAoB,KAAK,oBAAoB;EAC7C,oBAAoB,KAAK,mBAAmB;EAC5C,kCAAkC,IAAI,YAAY;EAClD,kCAAkC,IAAI,iBAAiB;EACvD,kCAAkC,IAAI,eAAe;EACrD,kCAAkC,IAAI,gBAAgB;EACtD,kCAAkC,IAAI,mBAAmB;EACzD,kCAAkC,IAAI,cAAc;EACpD,oBAAoB,kBAAkB,iCAAiC;;EAEvE,gEAAgE;EAChE,8DAA8D;EAC9D,gEAAgE;EAChE,gCAAgC,IAAI,mBAAmB;EACvD,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;;EAEnB,6BAA6B;EAC7B,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB,KAAK,6BAA6B;EACxD,sBAAsB,KAAK,6BAA6B;EACxD,yBAAyB,EAAE,iDAAiD;EAC5E,mCAAmC;;EAEnC,2DAA2D;EAC3D,qBAAqB;EACrB,qBAAqB;EACrB,oCAAoC;EACpC,mCAAmC;EACnC,mCAAmC;EACnC,yBAAyB;EACzB,uCAAuC;EACvC,uCAAuC;;EAEvC,gEAAgE;EAChE,wBAAwB;EACxB,gEAAgE;EAChE,iCAAiC;EACjC,oBAAoB;EACpB,iCAAiC;EACjC,oBAAoB;EACpB,gCAAgC;EAChC,oBAAoB;;EAEpB,gEAAgE;EAChE,8DAA8D;EAC9D,gEAAgE;EAChE,qBAAqB;EACrB,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;;EAE7B,4BAA4B;EAC5B,yCAAyC;EACzC,yCAAyC;EACzC,yCAAyC;EACzC,wCAAwC;EACxC,yCAAyC;EACzC,4BAA4B;;EAE5B,sBAAsB;EACtB,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;;EAE3B,2BAA2B;EAC3B,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;;EAE7B,qBAAqB;EACrB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;;EAExB,wBAAwB;EACxB,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,0BAA0B;EAC1B,0CAA0C;EAC1C,mCAAmC;EACnC,uCAAuC;;EAEvC,sBAAsB;EACtB,qCAAqC;EACrC,gCAAgC;EAChC,8BAA8B;EAC9B,kCAAkC;;EAElC,qCAAqC;EACrC,+BAA+B;EAC/B,mCAAmC;;EAEnC,gCAAgC;EAChC,qCAAqC;EACrC,6BAA6B;EAC7B,6BAA6B;EAC7B,2CAA2C;;EAE3C,uBAAuB;EACvB,6BAA6B;EAC7B,uBAAuB;EACvB,8BAA8B;;EAE9B,8BAA8B;EAC9B,iCAAiC;EACjC,oBAAoB;EACpB,oBAAoB;;EAEpB,+BAA+B;EAC/B,2BAA2B;EAC3B,wCAAwC;EACxC,2BAA2B;;EAE3B,kBAAkB;EAClB,gCAAgC;;EAEhC,mBAAmB;EACnB,gCAAgC;EAChC,kCAAkC;EAClC,sCAAsC;;EAEtC,mBAAmB;EACnB,kCAAkC;EAClC,uCAAuC;EACvC,4BAA4B;EAC5B,4BAA4B;;EAE5B,6CAA6C;EAC7C,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,8DAA8D;EAC9D,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;;EAE5B,4BAA4B;EAC5B,gCAAgC;EAChC,gCAAgC;EAChC,gCAAgC;EAChC,gCAAgC;EAChC,gCAAgC;EAChC,gCAAgC;;EAEhC,sCAAsC;EACtC,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;EAC7B,6BAA6B;;EAE7B,qBAAqB;EACrB,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;;EAE9B,0BAA0B;EAC1B,+BAA+B;EAC/B,yCAAyC;EACzC,kCAAkC;EAClC,wBAAwB;EACxB,wBAAwB;EACxB,kCAAkC;EAClC,sCAAsC;;EAEtC,gEAAgE;EAChE,YAAY;EACZ,gEAAgE;EAChE,qCAAqC;EACrC,sCAAsC;EACtC,uCAAuC;;EAEvC,gEAAgE;EAChE,YAAY;EACZ,gEAAgE;EAChE,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;;EAEnB,gEAAgE;EAChE,kBAAkB;EAClB,gEAAgE;EAChE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;;EAErB,gEAAgE;EAChE,gBAAgB;EAChB,gEAAgE;EAChE,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA,gEAAgE;AAChE,+DAA+D;AAC/D,gEAAgE;;AAEhE,iEAAiE;AACjE;EACE,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,yBAAyB;EACzB,mCAAmC;EACnC,mCAAmC;EACnC,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA,gEAAgE;AAChE;EACE,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,wBAAwB;EACxB,kCAAkC;EAClC,kCAAkC;EAClC,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA,gEAAgE;AAChE;EACE,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,yBAAyB;EACzB,mCAAmC;EACnC,mCAAmC;EACnC,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA,gEAAgE;AAChE;EACE,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,yBAAyB;EACzB,mCAAmC;EACnC,mCAAmC;EACnC,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA,gEAAgE;AAChE;EACE,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,yBAAyB;EACzB,mCAAmC;EACnC,mCAAmC;EACnC,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA,gEAAgE;AAChE;EACE,sBAAsB;EACtB,sBAAsB;EACtB,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,+BAA+B;EAC/B,8BAA8B;EAC9B,8BAA8B;EAC9B,yBAAyB;EACzB,iCAAiC;EACjC,iCAAiC;EACjC,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,yBAAyB;EACzB,mCAAmC;EACnC,mCAAmC;EACnC,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,iCAAiC;EACjC,+BAA+B;EAC/B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,0BAA0B;EAC1B,2BAA2B;EAC3B,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,oCAAoC;EACpC,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA,gEAAgE;AAChE;EACE,sBAAsB;EACtB,sBAAsB;EACtB,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,+BAA+B;EAC/B,8BAA8B;EAC9B,8BAA8B;EAC9B,yBAAyB;EACzB,iCAAiC;EACjC,iCAAiC;EACjC,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,wBAAwB;EACxB,kCAAkC;EAClC,kCAAkC;EAClC,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,wCAAwC;EACxC,wCAAwC;EACxC,0CAA0C;EAC1C,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,iCAAiC;AACnC;;AAEA,gEAAgE;AAChE;EACE,sBAAsB;EACtB,sBAAsB;EACtB,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,+BAA+B;EAC/B,8BAA8B;EAC9B,8BAA8B;EAC9B,yBAAyB;EACzB,iCAAiC;EACjC,iCAAiC;EACjC,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,yBAAyB;EACzB,mCAAmC;EACnC,mCAAmC;EACnC,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,wCAAwC;EACxC,wCAAwC;EACxC,0CAA0C;EAC1C,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,iCAAiC;AACnC;;AAEA,gEAAgE;AAChE;EACE,sBAAsB;EACtB,sBAAsB;EACtB,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,+BAA+B;EAC/B,8BAA8B;EAC9B,8BAA8B;EAC9B,yBAAyB;EACzB,iCAAiC;EACjC,iCAAiC;EACjC,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,wBAAwB;EACxB,kCAAkC;EAClC,kCAAkC;EAClC,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,wCAAwC;EACxC,wCAAwC;EACxC,0CAA0C;EAC1C,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,iCAAiC;AACnC;;AAEA,gEAAgE;AAChE;EACE,sBAAsB;EACtB,sBAAsB;EACtB,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,+BAA+B;EAC/B,8BAA8B;EAC9B,8BAA8B;EAC9B,yBAAyB;EACzB,iCAAiC;EACjC,iCAAiC;EACjC,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,wBAAwB;EACxB,kCAAkC;EAClC,kCAAkC;EAClC,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,wCAAwC;EACxC,wCAAwC;EACxC,0CAA0C;EAC1C,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,iCAAiC;AACnC;;AAEA,gEAAgE;AAChE;EACE,sBAAsB;EACtB,sBAAsB;EACtB,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,+BAA+B;EAC/B,8BAA8B;EAC9B,8BAA8B;EAC9B,yBAAyB;EACzB,iCAAiC;EACjC,iCAAiC;EACjC,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,wBAAwB;EACxB,kCAAkC;EAClC,kCAAkC;EAClC,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,wCAAwC;EACxC,wCAAwC;EACxC,0CAA0C;EAC1C,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,iCAAiC;AACnC;;AAEA,gEAAgE;AAChE,kBAAkB;AAClB,gEAAgE;;AAEhE;EACE,sBAAsB;AACxB;;AAEA;EACE,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;EAChC,2BAA2B;EAC3B,+BAA+B;EAC/B,uBAAuB;EACvB,iCAAiC;EACjC,SAAS;EACT,UAAU;AACZ;;AAEA;;;sDAGsD;;AAEtD,gEAAgE;AAChE,aAAa;AACb,gEAAgE;;AAEhE;EACE,SAAS;EACT,2BAA2B;EAC3B,8BAA8B;EAC9B,uBAAuB,GAAG,mCAAmC;AAC/D;;AAEA,gEAAgE;AAChE,mBAAmB;AACnB,gEAAgE;;AAEhE,kBAAkB,uBAAuB,EAAE;AAC3C,kBAAkB,uBAAuB,EAAE;AAC3C,kBAAkB,uBAAuB,EAAE;AAC3C,kBAAkB,uBAAuB,EAAE;AAC3C,kBAAkB,uBAAuB,EAAE;AAC3C,kBAAkB,qBAAqB,EAAE;AACzC,kBAAkB,sBAAsB,EAAE;;AAE1C,WAAW,yBAAyB,EAAE;AACtC,WAAW,yBAAyB,EAAE;AACtC,aAAa,2BAA2B,EAAE;AAC1C,WAAW,yBAAyB,EAAE;;AAEtC,gBAAgB,8BAA8B,EAAE;AAChD,eAAe,6BAA6B,EAAE;AAC9C,iBAAiB,+BAA+B,EAAE;AAClD,aAAa,2BAA2B,EAAE;;AAE1C,gEAAgE;AAChE,sBAAsB;AACtB,gEAAgE;;AAEhE;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;AAC9B","sourcesContent":["/**\r\n * Design System - Dark Theme\r\n * Foundation for the entire application — dark indigo\r\n */\r\n\r\n@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');\r\n\r\n:root {\r\n  /* ═══════════════════════════════════════════════════════════ */\r\n  /* TYPOGRAPHY */\r\n  /* ═══════════════════════════════════════════════════════════ */\r\n  --font-primary: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\r\n  --font-mono: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;\r\n\r\n  --text-xs: 12px;\r\n  --text-sm: 13px;\r\n  --text-base: 14px;\r\n  --text-lg: 16px;\r\n  --text-xl: 18px;\r\n  --text-2xl: 22px;\r\n  --text-3xl: 28px;\r\n\r\n  /* Line heights */\r\n  --line-tight: 1.25;\r\n  --line-normal: 1.5;\r\n  --line-relaxed: 1.75;\r\n\r\n  /* Font weights */\r\n  --fw-regular: 400;\r\n  --fw-medium: 500;\r\n  --fw-semibold: 600;\r\n  --fw-bold: 700;\r\n\r\n  /* ═══════════════════════════════════════════════════════════ */\r\n  /* COLORS - DARK THEME (replaces light slate scale)          */\r\n  /* ═══════════════════════════════════════════════════════════ */\r\n  /* Backgrounds / surfaces */\r\n  --slate-50:  #07090f;    /* page background */\r\n  --slate-100: #0d0f1a;    /* card / surface */\r\n  --slate-200: rgba(255,255,255,.07);   /* borders */\r\n  --slate-300: rgba(255,255,255,.14);   /* border hover */\r\n  --slate-400: rgba(255,255,255,.35);   /* muted text */\r\n  --slate-500: rgba(255,255,255,.45);   /* placeholder */\r\n  --slate-600: rgba(255,255,255,.55);   /* secondary text */\r\n  --slate-700: rgba(255,255,255,.70);   /* body text */\r\n  --slate-900: #e2e8f0;                 /* primary text (light on dark) */\r\n\r\n  /* ═══════════════════════════════════════════════════════════ */\r\n  /* COLORS - ACCENT (Indigo)                                  */\r\n  /* ═══════════════════════════════════════════════════════════ */\r\n  --blue-50:  rgba(99,102,241,.15);   /* active link bg */\r\n  --blue-500: #6366f1;\r\n  --blue-600: #6366f1;\r\n  --blue-700: #818cf8;\r\n\r\n  /* Shorthand accent aliases */\r\n  --accent:      #6366f1;\r\n  --accent-l:    #818cf8;\r\n  --accent-2:    #7c3aed;    /* secondary gradient shade */\r\n  --accent-dark: #4f46e5;    /* darker for hover states  */\r\n  --accent-rgb:  99,102,241; /* channels for rgba(var(--accent-rgb),opacity) */\r\n  --accent-g:    rgba(99,102,241,.25);\r\n\r\n  /* Surface helpers — used by inline styles and components */\r\n  --bg-card:    #0d0f1a;\r\n  --bg-surface: #0d0f1a;\r\n  --bg-toolbar: rgba(255,255,255,.025);\r\n  --bg-input:   rgba(255,255,255,.05);\r\n  --border:     rgba(255,255,255,.07);\r\n  --text-primary:   #e2e8f0;\r\n  --text-secondary: rgba(255,255,255,.55);\r\n  --text-muted:     rgba(255,255,255,.35);\r\n\r\n  /* ═══════════════════════════════════════════════════════════ */\r\n  /* COLORS - FUNCTIONAL */\r\n  /* ═══════════════════════════════════════════════════════════ */\r\n  --green-50:  rgba(16,185,129,.15);\r\n  --green-600: #10b981;\r\n  --amber-50:  rgba(245,158,11,.15);\r\n  --amber-600: #f59e0b;\r\n  --red-50:    rgba(239,68,68,.15);\r\n  --red-600:   #ef4444;\r\n\r\n  /* ═══════════════════════════════════════════════════════════ */\r\n  /* COLORS - CANVAS / TOPOLOGY / PORT STATUS                  */\r\n  /* ═══════════════════════════════════════════════════════════ */\r\n  /* Port status dots */\r\n  --port-complete-dot:  #0d9488;\r\n  --port-wall-dot:      #8b5cf6;\r\n  --port-switch-dot:    #3b82f6;\r\n  --port-free-dot:      #10b981;\r\n  --port-connected-dot: #86efac;\r\n  --port-uplink-dot:    #fcd34d;\r\n\r\n  /* Port status backgrounds */\r\n  --port-complete-bg:  rgba(13,148,136,.15);\r\n  --port-wall-bg:      rgba(139,92,246,.15);\r\n  --port-switch-bg:    rgba(59,130,246,.12);\r\n  --port-free-bg:      rgba(16,185,129,.1);\r\n  --port-selected-bg:  rgba(249,115,22,.18);\r\n  --port-selected-bd:  #f97316;\r\n\r\n  /* RSTP role colours */\r\n  --rstp-root:        #2563eb;\r\n  --rstp-designated:  #3b82f6;\r\n  --rstp-alternate:   #f59e0b;\r\n  --rstp-backup:      #b45309;\r\n  --rstp-disabled:    #9ca3af;\r\n\r\n  /* Service status colours */\r\n  --status-running:     #22c55e;\r\n  --status-stopped:     #ef4444;\r\n  --status-maintenance: #eab308;\r\n  --status-degraded:    #f97316;\r\n  --status-unknown:     #94a3b8;\r\n\r\n  /* Criticality ring */\r\n  --crit-critical: #ef4444;\r\n  --crit-high:     #f97316;\r\n  --crit-medium:   #eab308;\r\n  --crit-low:      #3b82f6;\r\n\r\n  /* Canvas node colours */\r\n  --node-self-bg:     #1e40af;\r\n  --node-self-stroke: #1e3a8a;\r\n  --node-self-text:   #e0f2fe;\r\n  --node-self-sub:    #93c5fd;\r\n  --node-edge-label-bg: #fff;\r\n  --node-selected-bg:   rgba(99,102,241,.15);\r\n  --node-selected-bd:   var(--accent);\r\n  --node-link-text:     var(--text-muted);\r\n\r\n  /* Uplink cloud stub */\r\n  --uplink-bg:     rgba(99,102,241,.08);\r\n  --uplink-stroke: var(--accent-l);\r\n  --uplink-text:   var(--accent);\r\n  --uplink-sub:    var(--text-muted);\r\n\r\n  /* Edge highlight in dependency map */\r\n  --edge-highlight: var(--accent);\r\n  --edge-normal:    var(--text-muted);\r\n\r\n  /* Connection banner / success */\r\n  --conn-banner-bg:     var(--green-50);\r\n  --conn-banner-bd:     #86efac;\r\n  --conn-arrow:         #16a34a;\r\n  --conn-cable-text:    var(--text-secondary);\r\n\r\n  /* Disconnect / error */\r\n  --error-bg:     var(--red-50);\r\n  --error-bd:     #fca5a5;\r\n  --error-text:   var(--red-600);\r\n\r\n  /* Warn / daisy-chain orange */\r\n  --warn-bg:   rgba(249,115,22,.08);\r\n  --warn-bd:   #fb923c;\r\n  --warn-text: #fb923c;\r\n\r\n  /* Wall outlet purple accents */\r\n  --wall-accent:      #a78bfa;\r\n  --wall-banner-bg:   rgba(139,92,246,.08);\r\n  --wall-banner-bd:   #c4b5fd;\r\n\r\n  /* Modal overlay */\r\n  --modal-overlay: rgba(0,0,0,.45);\r\n\r\n  /* Tab bar active */\r\n  --tab-active-bd:   var(--accent);\r\n  --tab-active-text: var(--accent-l);\r\n  --tab-inactive-text: var(--text-muted);\r\n\r\n  /* Button primary */\r\n  --btn-primary:       var(--accent);\r\n  --btn-primary-hover: var(--accent-dark);\r\n  --btn-danger:        #dc2626;\r\n  --btn-danger-hover:  #b91c1c;\r\n\r\n  /* ── Port card colours (SwitchPortsTab) ── */\r\n  --spt-outlet-bg:     #ede9fe;\r\n  --spt-outlet-fg:     #5b21b6;\r\n  --spt-outlet-bd:     #8b5cf6;\r\n  --spt-connected-bg:  #86efac;\r\n  --spt-connected-fg:  #14532d;\r\n  --spt-uplink-bg:     #fcd34d;\r\n  --spt-uplink-fg:     #78350f;\r\n  --spt-free-fg:       #475569;\r\n  --spt-inactive-bg:   #94a3b8;\r\n  --spt-inactive-fg:   #64748b;\r\n  --spt-mirror-bg:     linear-gradient(135deg, #a78bfa, #7c3aed);\r\n  --spt-mirror-bd:     #6d28d9;\r\n  --spt-empty-bg1:     #f1f5f9;\r\n  --spt-empty-bg2:     #e2e8f0;\r\n  --spt-empty-fg:      #94a3b8;\r\n  --spt-empty-bd:      #cbd5e1;\r\n\r\n  /* Connector badge colours */\r\n  --port-conn-default-bg:  #e5e7eb;\r\n  --port-conn-default-fg:  #374151;\r\n  --port-conn-fiber-bg:    #fef3c7;\r\n  --port-conn-fiber-fg:    #92400e;\r\n  --port-conn-sfp-bg:      #dbeafe;\r\n  --port-conn-sfp-fg:      #1e40af;\r\n\r\n  /* Port state colours (PortMapModal) */\r\n  --port-patched:       #86efac;\r\n  --port-pending:       #fcd34d;\r\n  --port-free:          #e2e8f0;\r\n  --port-inactive:      #94a3b8;\r\n  --port-inactive-text: #64748b;\r\n  --port-patched-text:  #14532d;\r\n  --port-pending-text:  #78350f;\r\n  --port-free-text:     #475569;\r\n\r\n  /* RSTP role badges */\r\n  --rstp-root-bg:        #dcfce7;\r\n  --rstp-root-fg:        #15803d;\r\n  --rstp-designated-bg:  #dbeafe;\r\n  --rstp-designated-fg:  #1d4ed8;\r\n  --rstp-alternate-bg:   #fef3c7;\r\n  --rstp-alternate-fg:   #b45309;\r\n  --rstp-backup-bg:      #fef9c3;\r\n  --rstp-backup-fg:      #92400e;\r\n  --rstp-disabled-bg:    #f3f4f6;\r\n  --rstp-disabled-fg:    #6b7280;\r\n\r\n  /* Editor / form colours */\r\n  --editor-bg:     var(--bg-card);\r\n  --editor-header-text: var(--text-primary);\r\n  --editor-label:  var(--text-muted);\r\n  --badge-on-bg:   #dcfce7;\r\n  --badge-on-fg:   #166534;\r\n  --badge-off-bg:  var(--bg-toolbar);\r\n  --badge-off-fg:  var(--text-secondary);\r\n\r\n  /* ═══════════════════════════════════════════════════════════ */\r\n  /* SHADOWS */\r\n  /* ═══════════════════════════════════════════════════════════ */\r\n  --shadow-sm: 0 1px 3px rgba(0,0,0,.4);\r\n  --shadow-md: 0 4px 12px rgba(0,0,0,.5);\r\n  --shadow-lg: 0 12px 32px rgba(0,0,0,.6);\r\n\r\n  /* ═══════════════════════════════════════════════════════════ */\r\n  /* SPACING */\r\n  /* ═══════════════════════════════════════════════════════════ */\r\n  --spacing-xs: 4px;\r\n  --spacing-sm: 8px;\r\n  --spacing-md: 12px;\r\n  --spacing-lg: 16px;\r\n  --spacing-xl: 24px;\r\n  --spacing-2xl: 32px;\r\n\r\n  /* ═══════════════════════════════════════════════════════════ */\r\n  /* BORDER RADIUS */\r\n  /* ═══════════════════════════════════════════════════════════ */\r\n  --radius-xs: 2px;\r\n  --radius-sm: 4px;\r\n  --radius-md: 6px;\r\n  --radius-lg: 8px;\r\n  --radius-xl: 12px;\r\n  --radius-full: 9999px;\r\n\r\n  /* ═══════════════════════════════════════════════════════════ */\r\n  /* TRANSITIONS */\r\n  /* ═══════════════════════════════════════════════════════════ */\r\n  --transition-fast: 0.15s ease;\r\n  --transition-normal: 0.3s ease;\r\n}\r\n\r\n/* ═══════════════════════════════════════════════════════════ */\r\n/* PALETTE OVERRIDES — each block only redefines what changes */\r\n/* ═══════════════════════════════════════════════════════════ */\r\n\r\n/* ── Midnight (Blue) ───────────────────────────────────────── */\r\n[data-theme=\"midnight\"] {\r\n  --slate-50:    #010a1e;\r\n  --slate-100:   #071525;\r\n  --bg-card:     #071525;\r\n  --bg-surface:  #071525;\r\n  --accent:      #3b82f6;\r\n  --accent-l:    #60a5fa;\r\n  --accent-2:    #2563eb;\r\n  --accent-dark: #1d4ed8;\r\n  --accent-rgb:  59,130,246;\r\n  --accent-g:    rgba(59,130,246,.25);\r\n  --blue-50:     rgba(59,130,246,.15);\r\n  --blue-500:    #3b82f6;\r\n  --blue-600:    #3b82f6;\r\n  --blue-700:    #60a5fa;\r\n  --bs-body-bg:  #010a1e;\r\n  --bs-card-bg:  #071525;\r\n}\r\n\r\n/* ── Ocean (Cyan) ─────────────────────────────────────────── */\r\n[data-theme=\"ocean\"] {\r\n  --slate-50:    #031318;\r\n  --slate-100:   #071c22;\r\n  --bg-card:     #071c22;\r\n  --bg-surface:  #071c22;\r\n  --accent:      #06b6d4;\r\n  --accent-l:    #22d3ee;\r\n  --accent-2:    #0891b2;\r\n  --accent-dark: #0e7490;\r\n  --accent-rgb:  6,182,212;\r\n  --accent-g:    rgba(6,182,212,.25);\r\n  --blue-50:     rgba(6,182,212,.15);\r\n  --blue-500:    #06b6d4;\r\n  --blue-600:    #06b6d4;\r\n  --blue-700:    #22d3ee;\r\n  --bs-body-bg:  #031318;\r\n  --bs-card-bg:  #071c22;\r\n}\r\n\r\n/* ── Aurora (Emerald) ─────────────────────────────────────── */\r\n[data-theme=\"aurora\"] {\r\n  --slate-50:    #031208;\r\n  --slate-100:   #071a0e;\r\n  --bg-card:     #071a0e;\r\n  --bg-surface:  #071a0e;\r\n  --accent:      #10b981;\r\n  --accent-l:    #34d399;\r\n  --accent-2:    #059669;\r\n  --accent-dark: #047857;\r\n  --accent-rgb:  16,185,129;\r\n  --accent-g:    rgba(16,185,129,.25);\r\n  --blue-50:     rgba(16,185,129,.15);\r\n  --blue-500:    #10b981;\r\n  --blue-600:    #10b981;\r\n  --blue-700:    #34d399;\r\n  --bs-body-bg:  #031208;\r\n  --bs-card-bg:  #071a0e;\r\n}\r\n\r\n/* ── Dusk (Rose) ──────────────────────────────────────────── */\r\n[data-theme=\"dusk\"] {\r\n  --slate-50:    #130810;\r\n  --slate-100:   #1c0e17;\r\n  --bg-card:     #1c0e17;\r\n  --bg-surface:  #1c0e17;\r\n  --accent:      #ec4899;\r\n  --accent-l:    #f472b6;\r\n  --accent-2:    #db2777;\r\n  --accent-dark: #be185d;\r\n  --accent-rgb:  236,72,153;\r\n  --accent-g:    rgba(236,72,153,.25);\r\n  --blue-50:     rgba(236,72,153,.15);\r\n  --blue-500:    #ec4899;\r\n  --blue-600:    #ec4899;\r\n  --blue-700:    #f472b6;\r\n  --bs-body-bg:  #130810;\r\n  --bs-card-bg:  #1c0e17;\r\n}\r\n\r\n/* ── Sunset (Amber) ───────────────────────────────────────── */\r\n[data-theme=\"sunset\"] {\r\n  --slate-50:    #130a03;\r\n  --slate-100:   #1a1006;\r\n  --bg-card:     #1a1006;\r\n  --bg-surface:  #1a1006;\r\n  --accent:      #f59e0b;\r\n  --accent-l:    #fbbf24;\r\n  --accent-2:    #d97706;\r\n  --accent-dark: #b45309;\r\n  --accent-rgb:  245,158,11;\r\n  --accent-g:    rgba(245,158,11,.25);\r\n  --blue-50:     rgba(245,158,11,.15);\r\n  --blue-500:    #f59e0b;\r\n  --blue-600:    #f59e0b;\r\n  --blue-700:    #fbbf24;\r\n  --bs-body-bg:  #130a03;\r\n  --bs-card-bg:  #1a1006;\r\n}\r\n\r\n/* ── Light ────────────────────────────────────────────────── */\r\n[data-theme=\"light\"] {\r\n  --slate-50:    #f1f5f9;\r\n  --slate-100:   #ffffff;\r\n  --slate-200:   rgba(0,0,0,.08);\r\n  --slate-300:   rgba(0,0,0,.15);\r\n  --slate-400:   rgba(0,0,0,.35);\r\n  --slate-500:   rgba(0,0,0,.45);\r\n  --slate-600:   rgba(0,0,0,.55);\r\n  --slate-700:   rgba(0,0,0,.70);\r\n  --slate-900:   #0f172a;\r\n  --bg-card:     #ffffff;\r\n  --bg-surface:  #ffffff;\r\n  --bg-toolbar:  rgba(0,0,0,.025);\r\n  --bg-input:    rgba(0,0,0,.04);\r\n  --border:      rgba(0,0,0,.08);\r\n  --text-primary:   #0f172a;\r\n  --text-secondary: rgba(0,0,0,.55);\r\n  --text-muted:     rgba(0,0,0,.35);\r\n  --accent:      #6366f1;\r\n  --accent-l:    #4f46e5;\r\n  --accent-2:    #7c3aed;\r\n  --accent-dark: #4338ca;\r\n  --accent-rgb:  99,102,241;\r\n  --accent-g:    rgba(99,102,241,.18);\r\n  --blue-50:     rgba(99,102,241,.12);\r\n  --blue-500:    #6366f1;\r\n  --blue-600:    #6366f1;\r\n  --blue-700:    #4f46e5;\r\n  --bs-body-bg:    #f1f5f9;\r\n  --bs-body-color: #0f172a;\r\n  --bs-card-bg:    #ffffff;\r\n  --bs-border-color: rgba(0,0,0,.1);\r\n  /* Canvas overrides for light */\r\n  --node-self-bg:     #1e40af;\r\n  --node-self-stroke: #1e3a8a;\r\n  --node-self-text:   #e0f2fe;\r\n  --node-self-sub:    #93c5fd;\r\n  --node-edge-label-bg: #fff;\r\n  --node-selected-bg: #eff6ff;\r\n  --uplink-bg:     #f0f9ff;\r\n  --uplink-stroke: #bae6fd;\r\n  --uplink-text:   #0369a1;\r\n  --uplink-sub:    #64748b;\r\n  --conn-banner-bg: #f0fdf4;\r\n  --conn-arrow:     #16a34a;\r\n  --error-bg:       #fee2e2;\r\n  --error-bd:       #fca5a5;\r\n  --warn-bg:        #fff7ed;\r\n  --warn-bd:        #fed7aa;\r\n  --warn-text:      #9a3412;\r\n  --wall-banner-bg: #faf5ff;\r\n  --wall-banner-bd: #c4b5fd;\r\n  --modal-overlay:  rgba(15,23,42,.55);\r\n  --editor-bg:      #ffffff;\r\n  --spt-empty-bg1:  #f1f5f9;\r\n  --spt-empty-bg2:  #e2e8f0;\r\n}\r\n\r\n/* ── Light Sky (Blue) ─────────────────────────────────────── */\r\n[data-theme=\"light-sky\"] {\r\n  --slate-50:    #f0f5ff;\r\n  --slate-100:   #ffffff;\r\n  --slate-200:   rgba(0,0,0,.08);\r\n  --slate-300:   rgba(0,0,0,.15);\r\n  --slate-400:   rgba(0,0,0,.35);\r\n  --slate-500:   rgba(0,0,0,.45);\r\n  --slate-600:   rgba(0,0,0,.55);\r\n  --slate-700:   rgba(0,0,0,.70);\r\n  --slate-900:   #0c1e3a;\r\n  --bg-card:     #ffffff;\r\n  --bg-surface:  #ffffff;\r\n  --bg-toolbar:  rgba(0,0,0,.025);\r\n  --bg-input:    rgba(0,0,0,.04);\r\n  --border:      rgba(0,0,0,.08);\r\n  --text-primary:   #0c1e3a;\r\n  --text-secondary: rgba(0,0,0,.55);\r\n  --text-muted:     rgba(0,0,0,.35);\r\n  --accent:      #0284c7;\r\n  --accent-l:    #0369a1;\r\n  --accent-2:    #0ea5e9;\r\n  --accent-dark: #075985;\r\n  --accent-rgb:  2,132,199;\r\n  --accent-g:    rgba(2,132,199,.18);\r\n  --blue-50:     rgba(2,132,199,.12);\r\n  --blue-500:    #0284c7;\r\n  --blue-600:    #0284c7;\r\n  --blue-700:    #0369a1;\r\n  --shadow-sm:   0 1px 3px rgba(0,0,0,.08);\r\n  --shadow-md:   0 4px 12px rgba(0,0,0,.1);\r\n  --shadow-lg:   0 12px 32px rgba(0,0,0,.12);\r\n  --bs-body-bg:    #f0f5ff;\r\n  --bs-body-color: #0c1e3a;\r\n  --bs-card-bg:    #ffffff;\r\n  --bs-border-color: rgba(0,0,0,.1);\r\n}\r\n\r\n/* ── Light Teal ───────────────────────────────────────────── */\r\n[data-theme=\"light-teal\"] {\r\n  --slate-50:    #f0fdfa;\r\n  --slate-100:   #ffffff;\r\n  --slate-200:   rgba(0,0,0,.08);\r\n  --slate-300:   rgba(0,0,0,.15);\r\n  --slate-400:   rgba(0,0,0,.35);\r\n  --slate-500:   rgba(0,0,0,.45);\r\n  --slate-600:   rgba(0,0,0,.55);\r\n  --slate-700:   rgba(0,0,0,.70);\r\n  --slate-900:   #0f2b2b;\r\n  --bg-card:     #ffffff;\r\n  --bg-surface:  #ffffff;\r\n  --bg-toolbar:  rgba(0,0,0,.025);\r\n  --bg-input:    rgba(0,0,0,.04);\r\n  --border:      rgba(0,0,0,.08);\r\n  --text-primary:   #0f2b2b;\r\n  --text-secondary: rgba(0,0,0,.55);\r\n  --text-muted:     rgba(0,0,0,.35);\r\n  --accent:      #0d9488;\r\n  --accent-l:    #0f766e;\r\n  --accent-2:    #14b8a6;\r\n  --accent-dark: #115e59;\r\n  --accent-rgb:  13,148,136;\r\n  --accent-g:    rgba(13,148,136,.18);\r\n  --blue-50:     rgba(13,148,136,.12);\r\n  --blue-500:    #0d9488;\r\n  --blue-600:    #0d9488;\r\n  --blue-700:    #0f766e;\r\n  --shadow-sm:   0 1px 3px rgba(0,0,0,.08);\r\n  --shadow-md:   0 4px 12px rgba(0,0,0,.1);\r\n  --shadow-lg:   0 12px 32px rgba(0,0,0,.12);\r\n  --bs-body-bg:    #f0fdfa;\r\n  --bs-body-color: #0f2b2b;\r\n  --bs-card-bg:    #ffffff;\r\n  --bs-border-color: rgba(0,0,0,.1);\r\n}\r\n\r\n/* ── Light Rose ───────────────────────────────────────────── */\r\n[data-theme=\"light-rose\"] {\r\n  --slate-50:    #fff1f2;\r\n  --slate-100:   #ffffff;\r\n  --slate-200:   rgba(0,0,0,.08);\r\n  --slate-300:   rgba(0,0,0,.15);\r\n  --slate-400:   rgba(0,0,0,.35);\r\n  --slate-500:   rgba(0,0,0,.45);\r\n  --slate-600:   rgba(0,0,0,.55);\r\n  --slate-700:   rgba(0,0,0,.70);\r\n  --slate-900:   #2a0f1e;\r\n  --bg-card:     #ffffff;\r\n  --bg-surface:  #ffffff;\r\n  --bg-toolbar:  rgba(0,0,0,.025);\r\n  --bg-input:    rgba(0,0,0,.04);\r\n  --border:      rgba(0,0,0,.08);\r\n  --text-primary:   #2a0f1e;\r\n  --text-secondary: rgba(0,0,0,.55);\r\n  --text-muted:     rgba(0,0,0,.35);\r\n  --accent:      #e11d48;\r\n  --accent-l:    #be123c;\r\n  --accent-2:    #f43f5e;\r\n  --accent-dark: #9f1239;\r\n  --accent-rgb:  225,29,72;\r\n  --accent-g:    rgba(225,29,72,.18);\r\n  --blue-50:     rgba(225,29,72,.12);\r\n  --blue-500:    #e11d48;\r\n  --blue-600:    #e11d48;\r\n  --blue-700:    #be123c;\r\n  --shadow-sm:   0 1px 3px rgba(0,0,0,.08);\r\n  --shadow-md:   0 4px 12px rgba(0,0,0,.1);\r\n  --shadow-lg:   0 12px 32px rgba(0,0,0,.12);\r\n  --bs-body-bg:    #fff1f2;\r\n  --bs-body-color: #2a0f1e;\r\n  --bs-card-bg:    #ffffff;\r\n  --bs-border-color: rgba(0,0,0,.1);\r\n}\r\n\r\n/* ── Light Amber ──────────────────────────────────────────── */\r\n[data-theme=\"light-amber\"] {\r\n  --slate-50:    #fffbeb;\r\n  --slate-100:   #ffffff;\r\n  --slate-200:   rgba(0,0,0,.08);\r\n  --slate-300:   rgba(0,0,0,.15);\r\n  --slate-400:   rgba(0,0,0,.35);\r\n  --slate-500:   rgba(0,0,0,.45);\r\n  --slate-600:   rgba(0,0,0,.55);\r\n  --slate-700:   rgba(0,0,0,.70);\r\n  --slate-900:   #2a1f0a;\r\n  --bg-card:     #ffffff;\r\n  --bg-surface:  #ffffff;\r\n  --bg-toolbar:  rgba(0,0,0,.025);\r\n  --bg-input:    rgba(0,0,0,.04);\r\n  --border:      rgba(0,0,0,.08);\r\n  --text-primary:   #2a1f0a;\r\n  --text-secondary: rgba(0,0,0,.55);\r\n  --text-muted:     rgba(0,0,0,.35);\r\n  --accent:      #d97706;\r\n  --accent-l:    #b45309;\r\n  --accent-2:    #f59e0b;\r\n  --accent-dark: #92400e;\r\n  --accent-rgb:  217,119,6;\r\n  --accent-g:    rgba(217,119,6,.18);\r\n  --blue-50:     rgba(217,119,6,.12);\r\n  --blue-500:    #d97706;\r\n  --blue-600:    #d97706;\r\n  --blue-700:    #b45309;\r\n  --shadow-sm:   0 1px 3px rgba(0,0,0,.08);\r\n  --shadow-md:   0 4px 12px rgba(0,0,0,.1);\r\n  --shadow-lg:   0 12px 32px rgba(0,0,0,.12);\r\n  --bs-body-bg:    #fffbeb;\r\n  --bs-body-color: #2a1f0a;\r\n  --bs-card-bg:    #ffffff;\r\n  --bs-border-color: rgba(0,0,0,.1);\r\n}\r\n\r\n/* ── Light Emerald ────────────────────────────────────────── */\r\n[data-theme=\"light-emerald\"] {\r\n  --slate-50:    #ecfdf5;\r\n  --slate-100:   #ffffff;\r\n  --slate-200:   rgba(0,0,0,.08);\r\n  --slate-300:   rgba(0,0,0,.15);\r\n  --slate-400:   rgba(0,0,0,.35);\r\n  --slate-500:   rgba(0,0,0,.45);\r\n  --slate-600:   rgba(0,0,0,.55);\r\n  --slate-700:   rgba(0,0,0,.70);\r\n  --slate-900:   #0a2a1b;\r\n  --bg-card:     #ffffff;\r\n  --bg-surface:  #ffffff;\r\n  --bg-toolbar:  rgba(0,0,0,.025);\r\n  --bg-input:    rgba(0,0,0,.04);\r\n  --border:      rgba(0,0,0,.08);\r\n  --text-primary:   #0a2a1b;\r\n  --text-secondary: rgba(0,0,0,.55);\r\n  --text-muted:     rgba(0,0,0,.35);\r\n  --accent:      #059669;\r\n  --accent-l:    #047857;\r\n  --accent-2:    #10b981;\r\n  --accent-dark: #065f46;\r\n  --accent-rgb:  5,150,105;\r\n  --accent-g:    rgba(5,150,105,.18);\r\n  --blue-50:     rgba(5,150,105,.12);\r\n  --blue-500:    #059669;\r\n  --blue-600:    #059669;\r\n  --blue-700:    #047857;\r\n  --shadow-sm:   0 1px 3px rgba(0,0,0,.08);\r\n  --shadow-md:   0 4px 12px rgba(0,0,0,.1);\r\n  --shadow-lg:   0 12px 32px rgba(0,0,0,.12);\r\n  --bs-body-bg:    #ecfdf5;\r\n  --bs-body-color: #0a2a1b;\r\n  --bs-card-bg:    #ffffff;\r\n  --bs-border-color: rgba(0,0,0,.1);\r\n}\r\n\r\n/* ═══════════════════════════════════════════════════════════ */\r\n/* GLOBAL STYLES */\r\n/* ═══════════════════════════════════════════════════════════ */\r\n\r\n* {\r\n  box-sizing: border-box;\r\n}\r\n\r\nhtml {\r\n  -webkit-font-smoothing: antialiased;\r\n  -moz-osx-font-smoothing: grayscale;\r\n}\r\n\r\nbody {\r\n  font-family: var(--font-primary);\r\n  font-size: var(--text-base);\r\n  line-height: var(--line-normal);\r\n  color: var(--slate-900);\r\n  background-color: var(--slate-50);\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\n/* ── Grid overlay ────────────────────────────────────────────\r\n * Retirado: la rejilla que se veía en todas las pantallas vive ahora en\r\n * `styles/background.css` como opción (`data-bg=\"mesh\"`) y por defecto se\r\n * sustituye por un campo de degradados difuminados. */\r\n\r\n/* ═══════════════════════════════════════════════════════════ */\r\n/* HEADINGS */\r\n/* ═══════════════════════════════════════════════════════════ */\r\n\r\nh1, h2, h3, h4, h5, h6 {\r\n  margin: 0;\r\n  font-weight: var(--fw-bold);\r\n  line-height: var(--line-tight);\r\n  color: var(--slate-900);  /* now light (#e2e8f0) on dark bg */\r\n}\r\n\r\n/* ═══════════════════════════════════════════════════════════ */\r\n/* TEXT UTILITIES */\r\n/* ═══════════════════════════════════════════════════════════ */\r\n\r\n.text-primary   { color: var(--slate-900); }\r\n.text-secondary { color: var(--slate-600); }\r\n.text-muted     { color: var(--slate-400); }\r\n.text-success   { color: var(--green-600); }\r\n.text-warning   { color: var(--amber-600); }\r\n.text-error     { color: var(--red-600); }\r\n.text-link      { color: var(--accent-l); }\r\n\r\n.text-xs { font-size: var(--text-xs); }\r\n.text-sm { font-size: var(--text-sm); }\r\n.text-base { font-size: var(--text-base); }\r\n.text-lg { font-size: var(--text-lg); }\r\n\r\n.font-regular { font-weight: var(--fw-regular); }\r\n.font-medium { font-weight: var(--fw-medium); }\r\n.font-semibold { font-weight: var(--fw-semibold); }\r\n.font-bold { font-weight: var(--fw-bold); }\r\n\r\n/* ═══════════════════════════════════════════════════════════ */\r\n/* SCROLLBAR STYLING */\r\n/* ═══════════════════════════════════════════════════════════ */\r\n\r\n::-webkit-scrollbar {\r\n  width: 8px;\r\n  height: 8px;\r\n}\r\n\r\n::-webkit-scrollbar-track {\r\n  background: transparent;\r\n}\r\n\r\n::-webkit-scrollbar-thumb {\r\n  background: var(--slate-300);\r\n  border-radius: 4px;\r\n}\r\n\r\n::-webkit-scrollbar-thumb:hover {\r\n  background: var(--slate-400);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
